import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { ErrorCard } from 'components/errorCard';
import { GroupedCards } from 'components/groupedCards';
import { LoaderCard } from 'components/loaderCard';
import { translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import { ENGAGEMENT_LABELS } from 'modules/userManager/constants';
import BigNumbersEngagementBars from 'modules/userManager/usersList/bigNumbers/BigNumbersEngagementBars';
import EngagementModal from 'modules/userManager/usersList/bigNumbers/EngagementModal';
import PropTypes from 'prop-types';

import DashboardEvents from '../../DashboardEvents';
import DashboardService from '../../DashboardService';
import { UserCard } from '../userCard';

import './UserReports.scss';

class UserReports extends Component {
  static propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    marketplaceId: PropTypes.number,
    userData: PropTypes.shape({
      loading: PropTypes.bool,
      error: PropTypes.bool,
      avgProgress: PropTypes.string,
      avgEngagement: PropTypes.number,
      areaTotalUsers: PropTypes.string,
      conclusionPercentage: PropTypes.string,
      percentTotalUsers: PropTypes.string
    })
  };

  state = {
    showEngagementModal: false
  };

  constructor(props) {
    super(props);

    this.buttonProps = {
      label: 'general.see_users',
      onClick: this.redirectToUsers
    };
  }

  get userData() {
    return this.props.userData || {};
  }

  get showableLoader() {
    return this.userData.loading;
  }

  get showableError() {
    return !this.showableLoader && this.userData.error;
  }

  get showableContent() {
    return !this.showableLoader && !this.showableError;
  }

  redirectToUsers = () => {
    const { marketplaceId } = this.props;

    DashboardEvents.clickOnUserButton(marketplaceId);

    this.props.history.push(ROUTES.USER.LIST);
  };

  openEngagementModal = () => this.setState({ showEngagementModal: true });

  closeEngagementModal = () => this.setState({ showEngagementModal: false });

  renderCards() {
    const { t } = this.props;

    const { avgProgress, avgEngagement, areaTotalUsers, conclusionPercentage } =
      this.userData;

    const engagementLabel = t(
      ENGAGEMENT_LABELS[avgEngagement] || ENGAGEMENT_LABELS[0]
    );

    const cards = [
      {
        'title': t('general.total'),
        'value': areaTotalUsers,
        'className': 'total_users',
        'data-test': 'total-users'
      },
      {
        'title': t('users_manager.big_numbers.conclusion_avg.title'),
        'value': conclusionPercentage,
        'className': 'completed_the_course',
        'data-test': 'completed-the-course'
      },
      {
        'title': t('general.progress'),
        'value': avgProgress,
        'className': 'progress',
        'data-test': 'progress'
      },
      {
        'title': t('general.engagement'),
        'value': engagementLabel,
        'className': 'engagement',
        'data-test': 'engagement',
        'children': <BigNumbersEngagementBars activeItem={avgEngagement} />
      }
    ];

    return cards.map((props, key) => (
      <UserCard {...props} key={key} index={key} />
    ));
  }

  renderCardContent = () =>
    this.showableContent ? (
      this.renderCards()
    ) : (
      <GroupedCards.Item>
        {this.showableLoader && <LoaderCard data-test="loader-card" />}
        {this.showableError && (
          <ErrorCard
            onClick={DashboardService.fetchUserData}
            data-test="error-card"
          />
        )}
      </GroupedCards.Item>
    );

  render() {
    const { showEngagementModal } = this.state;

    return (
      <div className="dashboard__item user_reports">
        <GroupedCards
          title={this.props.t('general.users')}
          buttonProps={this.buttonProps}
        >
          {this.renderCardContent()}
        </GroupedCards>
        {showEngagementModal && (
          <EngagementModal onClose={this.closeEngagementModal} />
        )}
      </div>
    );
  }
}

export default translate()(withRouter(UserReports));

export { UserReports };
